import LoadingBlock from './LoadingBlock';

export default LoadingBlock;
